import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import Notiflix from "notiflix";

// ANT DESIGN IMPORTS
import {
  Spin,
  Typography,
  Collapse,
  Button,
  Divider,
  Modal,
  Row,
  Col,
  Form,
  Select,
  DatePicker,
  InputNumber,
  Input,
} from "antd";
import { EditOutlined, PlusCircleOutlined } from "@ant-design/icons";

//PROJECT IMPORTS
import { BOM } from "../../../../../../services/definedMethod";
import cnt from "../../../../../../services/definedConstant";
import {
  apiConfig,
  labelConfig,
  staticConfig,
} from "../../../../customer.config";
import styles from "../../../../../../assets/styles/styles";
import { showCheckerApprovalModal } from "../../../../../../components/CheckerModal";
import { useNavigate } from "react-router-dom";

const EditKYCAddedTaxJurisdictionInfo = (props) => {
  const {
    currentCustomerObj,
    customerDetails,
    userData,
    countryData,
    refreshList,
    useForm,
  } = props;
  const { session } = userData;
  const [currencyData, setCurrencyData] = useState([]);
  const [liabilityData, setLiabilityData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  // MODAL VARIABLES
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    BOM.HasPermission("READ_CLIENT_LIMIT") && getTemplate();
  }, []);

  function getTemplate() {
    const params = {};
    const url = `${apiConfig.ClientLimit}/template`;
    let body = {
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
        setIsLoading(false);
      } else {
        const objDetail = res;
        let tempLiability = [];
        let tempCurrency = [];

        objDetail?.liabilityCategories.forEach((element) => {
          tempLiability.push({
            value: element.id,
            label: element.name,
          });
        });

        objDetail?.currencyOptions?.forEach((element) => {
          tempCurrency.push({
            value: element.code,
            label: element.displayLabel,
          });
        });

        setCurrencyData(tempCurrency);
        setLiabilityData(tempLiability);
        // SHOW THE SAVED DATA
        useForm.setFieldsValue({
          revolvingLine: objDetail.revolvingLine,
          retrieveCollaterals: objDetail.retrieveCollaterals,
          isActive: objDetail.isActive,
        });
        setIsLoading(false);
      }
    });
  }
  const onSubmit = (formValues) => {
    formValues.externalId = currentCustomerObj.id;
    formValues.dateFormat = "dd MMMM yyyy";
    formValues.isCustomerDirector = formValues.directorCustomer;
    formValues.hasEstablishedRelationship = formValues.establishedRelationship;
    formValues.expiryDate = formValues.expiryDate
      ? BOM.DateTime(formValues.expiryDate, "only-date")
      : BOM.DateTime(customerDetails?.expiryDate, "only-date");

    delete formValues.directorCustomer;
    delete formValues.establishedRelationship;

    const url = `${apiConfig.Clients}/${currentCustomerObj.id}`;

    const body = {
      ...formValues,
      locale: "en",
      method: "PUT",
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, labelConfig.updateKycMsg);

          // close modal
          setIsModalOpen(false);

          //refresh the list
          refreshList();

          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          setIsLoading(false);
        },
      }
    );
  };
  return (
    <>
      {BOM.HasPermission("CREATE_CLIENT_LIMIT") && (
        <Button
          type="primary"
          shape="round"
          className="of-primaryBtnColor"
          style={{
            marginLeft: "auto",
          }}
          onClick={showModal}
        >
          <EditOutlined />
          &nbsp;{labelConfig.edit}
        </Button>
      )}
      <Modal
        title="Edit KYC info"
        open={isModalOpen}
        okText="Save"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        // onOk={onSubmit}
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form
            layout="vertical"
            form={useForm}
            initialValues={{
              unAuthorisedLimit: 0,
              utilizedLimit: 0,
              unUsedLimit: 0,
              digitsAfterDecimal: 2,
              inMultiplesOf: 100,
            }}
            onFinish={onSubmit}
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Saving..." size="large">
          <Row>
            <Divider orientation="left">
              `{labelConfig.addedTaxJurisdiction} Information`
            </Divider>

            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.country} name="countryOfRisk">
                <Select
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.country} *`,
                    "select"
                  )}
                  options={countryData}
                />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </>
  );
};

export default EditKYCAddedTaxJurisdictionInfo;
